import type { PropsWithChildren, FunctionComponent, ReactNode } from 'react'
import { type TestableProps } from '../../common/utils/testing/testing.types'
import { Flex } from '../flex/Flex'
import { type OverridableStyles } from '../../common/utils/styling/styling.types'

interface Props extends TestableProps, OverridableStyles {
  leftComponents?: ReadonlyArray<ReactNode>
  rightComponents?: ReadonlyArray<ReactNode>
}

export const DashContentBar: FunctionComponent<PropsWithChildren<Props>> = ({
  leftComponents,
  rightComponents,
  overrideStyle,
}) => (
  <Flex
    justify="space-between"
    wrap="nowrap"
    fillWidth
    margin={['none', 'small']}
    overrideStyle={overrideStyle}
  >
    <Flex wrap="nowrap" overrideChildStyles={{ marginRight: 'xsmall' }}>
      {leftComponents}
    </Flex>

    <Flex
      justify="flex-end"
      align="center"
      wrap="nowrap"
      overrideChildStyles={{ marginLeft: 'xsmall' }}
    >
      {rightComponents}
    </Flex>
  </Flex>
)
